import http from '../../http-common'
import { UploadMediaResponse } from '@/helper/interfaces'

export default class MediaUploadService {
  private subdomain = 'media'
  private locationId: string

  constructor(locationId: string) {
    this.locationId = locationId
  }

  get endpoint() {
    return `/locations/${this.locationId}/${this.subdomain}`
  }

  uploadFile(payload: {
    file: Blob
    type: string
    filename?: string
    folder?: string
    progressUpdate?: any
  }): Promise<UploadMediaResponse> {
    const formData = new FormData()
    formData.append('file', payload.file)
    formData.append('type', payload.type)

    if (payload.filename) {
      formData.append('filename', payload.filename)
    }

    if (payload.folder) {
      formData.append('folder', payload.folder)
    }

    const config = {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress: (progressEvent: ProgressEvent) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        )
        if (payload.progressUpdate) {
          payload.progressUpdate(percentCompleted)
        }
      }
    }

    return http.post(this.endpoint, formData, config).then(res => {
      const { data } = res
      const { path: url, thumb: thumbnail } = data
      return { url, thumbnail } as UploadMediaResponse
    })
  }
}
